module.exports = __webpack_public_path__ + "img/7z.8ba31c33.png";